<!--提交订单-->
<template>
  <div class="order-container">
    <headerIndex/>
    <div class="order-content" :style="'min-height:'+min_height+'px;'">
      <p class="span-red SourceHanSansCN">填写并核对订单信息</p>
      <div class="receipt-info">
        <p class="title-content">
          <span class="left-span">收货人信息</span>
          <el-link type="primary" :underline="false">新增收货地址</el-link>
        </p>
        <div v-if="addressInfo" style="margin-block-start: 0em;margin-block-end: 0em;line-height: 10px;padding-bottom: 20px;cursor: context-menu;">
          <p>{{ addressInfo.name }} {{ addressInfo.mobile }}</p>
          <p>{{ addressInfo.city_name }}-{{ addressInfo.area_name }}-{{ addressInfo.address }}</p>
        </div>
        <div v-else style="text-align: center;">
          <el-link class="add-address" :underline="false" icon="el-icon-location">请填写收货地址</el-link>
        </div>
      </div>
      <!--商品信息-->
      <div class="goods-info">
        <p class="title-content">
          <span class="left-span">商品信息</span>
        </p>
        <div class="good-info">
          <el-image style="height: 110px;width: 100px;" :src="goodsDetails.bgGood.image" fit="contain"/>
          <div class="goods-describe">
            <p class="goods-name">{{ goodsDetails.bgGood.name }}</p>
            <p class="goods-gray" v-if="orderInfo.city">办理地区：{{ orderInfo.provinceName }}-{{ orderInfo.cityName }}</p>
            <p class="goods-gray">数量：{{ orderInfo.count }}件</p>
            <p class="goods-price"><span
                style="padding-right: 5px;">￥</span>{{ parseFloat(goodsDetails.bgGood.price).toFixed(2) }}</p>
            <el-input placeholder="请提前与商家沟通" v-model="orderInfo.remark"
                      style="margin-left: 20px;width: 99%;margin-top: 10px;">
              <i slot="prefix" class="el-remarks">备注：</i>
            </el-input>
          </div>
        </div>
      </div>
      <!--优惠券-->
      <div class="favourable-info" v-if="is_coupon">
        <el-collapse :accordion="true" v-model="activeName">
          <el-collapse-item title="红包优惠" name="1">
            <div style="padding-left: 20px;">
              <el-radio v-model="orderInfo.coupon" :label="coupon.couponId" border v-for="coupon of couponList" v-if="coupon.isReceive==1">
                <el-container>
                  <el-aside width="">
                    <p class="price"><span style="font-size: 14px">￥</span>{{ coupon.preferentialAmount }}</p>
                    <p class="coupon-type">店铺优惠券</p>
                  </el-aside>
                  <el-main>
                    <p class="coupon-term" style="padding-bottom: 5px;">满{{coupon.usingDoor}}减{{coupon.preferentialAmount}}</p>
                    <p class="coupon-term">{{coupon.startTime}}-{{coupon.endTime}}</p>
                  </el-main>
                </el-container>
              </el-radio>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="un-favourable-info" v-else>
        <p class="title-content">
          <span class="left-span">红包优惠</span>
        </p>
        <p class="title-content">
          <span class="left-span" style="color: #999999">无可用优惠券</span>
          <i class="el-icon-arrow-right"/>
        </p>
      </div>
      <!--支付方式-->
      <div class="payment-method">
        <p class="title-content">
          <span class="left-span">选择支付方式</span>
        </p>
        <div class="el-div" style="margin-top: 10px;">
          <el-radio v-model="orderInfo.type" label="微信支付" border>
            <div class="payment-type">
              <div class="icon-wechat"></div>
              <p class="coupon-term" style="padding-bottom: 5px;">微信支付</p>
            </div>
          </el-radio>
        </div>
        <!--<div class="el-div">
          <el-radio v-model="orderInfo.type" label="支付宝支付" border>
            <div class="payment-type">
              <div class="icon-alipay"></div>
              <p class="coupon-term" style="padding-bottom: 5px;">支付宝支付</p>
            </div>
          </el-radio>
        </div>-->
        <div class="el-div">
          <el-radio v-model="orderInfo.type" label="余额支付" border>
            <div class="payment-type">
              <div class="icon-balance"></div>
              <p class="coupon-term" style="padding-bottom: 5px;">帮企余额支付</p>
            </div>
          </el-radio>
        </div>
      </div>
      <div class="resoult-info">
        <p>
          <span class="left-span">总金额：</span>
          <span class="right-span">￥{{parseFloat(orderInfo.priceTotail).toFixed(2)}}</span>
        </p>
        <p>
          <span class="left-span">优惠券：</span>
          <span class="right-span red-span">-￥{{parseFloat(orderInfo.reduction).toFixed(2)}}</span>
        </p>
        <p>
          <span class="left-span SourceHanSansCN">应付金额：</span>
          <span class="right-span SourceHanSansCN red-span">￥{{parseFloat(parseFloat(orderInfo.priceTotail)-parseFloat(orderInfo.reduction)).toFixed(2)}}</span>
        </p>
        <el-button type="danger" @click="payCheck">提交订单</el-button>
      </div>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import Home_footer from "@/components/footer/home_footer";
import headerIndex from "@/components/header/headerIndex";
import Hang from "@/components/Hang/Hang";
import {couponsAvailableList, newEvaluate,submitOrder} from "@/api/cloudServiceApi";
import {setUpAddressList} from '@/api/systemSetting'
import cryptoJs from 'crypto-js'
export default {
  name: "order",
  components: {Hang, headerIndex, Home_footer},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 275,
      keyOne: '3132333435363738393041424344454631323334353637383930414243444566',
      addressInfo: {},
      goodsDetails: {
        bqwShop: {name: ''},
        bgGood: {name: ''},
        goodsComments: [],
        banLiCitys: [],
        xiangqing: [],
      },
      orderInfo: {
        goodId: 0,
        province: 0,
        city: 0,
        count: 0,
        provinceName: '',
        cityName: '',
        remark: '',
        coupon: '',
        priceTotail:0,
        reduction:0,
        type:'',
      },
      activeName: '1',
      cid:0,
      couponList:[],
      is_coupon:false,
    }
  },
  watch: {
    'orderInfo.coupon': {
      handler(n, old) {
        for (let coupon of this.couponList){
          if (coupon.couponId=n){
            this.orderInfo.reduction=coupon.preferentialAmount;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    // 加密函數
    jiami(word) {
      let key = cryptoJs.enc.Hex.parse(this.keyOne)
      let enc = ''
      if (typeof word === 'string') {
        enc = cryptoJs.AES.encrypt(word, key, {
          mode: cryptoJs.mode.ECB,
          padding: cryptoJs.pad.Pkcs7
        })
      } else if (typeof word === 'object') {
        let data = JSON.stringify(word)
        enc = cryptoJs.AES.encrypt(data, key, {
          mode: cryptoJs.mode.ECB,
          padding: cryptoJs.pad.Pkcs7
        })
      }
      let encResult = enc.ciphertext.toString()
      return encResult
    },
    payCheck(){
      let data={
        cid:this.cid != 0 && this.cid != undefined ? this.cid : 0,/*用户id*/
        goods_id:this.orderInfo.goodId,/*商品id*/
        goods_attr_id:'',/*商品属性id【网博会商品规格id】*/
        ordernum:'',/*订单号*/
        shop_id:this.goodsDetails.bqwShop.id,/*店铺id*/
        description:this.orderInfo.remark,/*订单留言*/
        amount:this.orderInfo.count,/*数量*/
        total:parseFloat(parseFloat(this.orderInfo.priceTotail)-parseFloat(this.orderInfo.reduction)).toFixed(2),/*总金额*/
        type:0,/*交易类型 0 商品 1其他*/
        consigneeUser:this.addressInfo.name,/*收货人*/
        consigneePhone:this.addressInfo.mobile,/*收货人手机号*/
        payType:this.orderInfo.type,/*支付方式*/
        myCouponId:this.orderInfo.coupon,/*我的优惠卷id(传用户领取的面额id)*/
        myGotCouponsId:this.orderInfo.coupon,/*我领取的优惠卷id*/
        orderType:1,/*订单类型（1：帮企网（默认），2：网博会）*/
        payAddress:this.addressInfo.city_name+'-'+this.addressInfo.area_name+'-'+this.addressInfo.address,/*收货地址*/
        handlingAreaId:this.orderInfo.provinceName+'-'+this.orderInfo.cityName,/*办理地区id（只有第三方商品有 并且该商品已选择地区模板）*/
      }
      submitOrder({parame: this.jiami(JSON.stringify(data)), request: 'form', uid: this.cid != 0 && this.cid != undefined ? this.cid : 0}).then(res=>{
        if (res.code==200){
          this.$router.push({
            path: '/payment/payCheck',
            query:{id: res.content.id, ordernum: res.content.ordernum,price:JSON.stringify(data.total)}
          })
        }
      })
    },
    /*获取商品信息*/
    getGoodsInfo(){
      newEvaluate({
        id: this.orderInfo.goodId,
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.goodsDetails = res.content;
          this.orderInfo.priceTotail=this.goodsDetails.bgGood.price*this.orderInfo.count;
        }
      })
    },
    /*获取店铺优惠券*/
    getCouponInfo(){
      couponsAvailableList({
        id: this.orderInfo.goodId,
        request: 'form',
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.couponList = res.content.coupon;
          for (let coupon of this.couponList){
            if (coupon.isReceive==1 && coupon.usingDoor<=this.goodsDetails.bgGood.price)
              this.is_coupon=true;
          }
        }
      })
    },
    /*获取收货地址*/
    getUpAddressList(){
      setUpAddressList({uid:this.cid != 0 && this.cid != undefined ? this.cid : 0}).then(res=>{
        if (res.code==200){
          this.addressInfo=res.content[0];
        }
      })
    }
  },
  mounted() {
    this.getGoodsInfo();
    this.getCouponInfo();
    this.getUpAddressList();
  },
  beforeMount() {
    this.orderInfo.city = this.$route.query.city;
    this.orderInfo.goodId = this.$route.query.goodId;
    this.orderInfo.province = this.$route.query.province;
    this.orderInfo.count = this.$route.query.count;
    this.orderInfo.provinceName = this.$route.query.province_name;
    this.orderInfo.cityName = this.$route.query.city_name;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>
<style scoped>
.order-container >>> .order-content .goods-info .good-info .goods-describe .el-input--prefix .el-input__inner {
  padding-left: 65px;
  color: #999999;
  background: #F9F9F9;
  border: 1px solid #dddddd;
}

.order-container >>> .order-content .favourable-info .el-aside {
  overflow: inherit;
  box-sizing: border-box;
  flex-shrink: inherit;
}
.order-container >>> .order-content .favourable-info .el-radio.is-bordered {
  padding: 12px 20px 13px 10px;
  border-radius: 6px;
  border: 1px solid #FFB2BA;
  box-sizing: border-box;
  height: auto;
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  float: left;
  background: #FFEBED;
}
.order-container >>> .order-content .payment-method .el-radio.is-bordered {
  padding: 5px 20px 5px 0px;
  border-radius: 6px;
  border: none;
  box-sizing: border-box;
  height: auto;
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  float: left;
  background: center;
}

.order-container >>> .order-content .el-radio__input {
  line-height: 4;
}
.order-container >>> .order-content .payment-method .el-radio__input {
  line-height: 24px;
}
.order-container >>> .order-content .el-radio__inner {
  border: 1px solid #FE273B;
  background: center;
}
.order-container >>> .order-content .el-radio__input.is-checked .el-radio__inner {
  border-color: #FE273B;
  background-color: #FE273B;
}
.order-container >>> .order-content .favourable-info .el-card__body, .el-main {
  padding: 10px 0px 0px 20px;
  overflow: hidden;
}
.order-container >>> .order-content .favourable-info .el-collapse-item__header {
  display: flex;
  align-items: center;
  height: 48px;
  line-height: 48px;
  background-color: #FFF;
  color: #303133;
  cursor: pointer;
  border-bottom: 1px solid #DDDDDD;
  font-size: 13px;
  font-weight: 500;
  padding: 0px 20px;
  transition: border-bottom-color .3s;
  outline: 0;
  margin-bottom: 20px;
}
.order-container >>> .order-content .resoult-info .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  float: right;
  padding: 15px 60px;
  margin-top: 10px;
}
</style>
<style scoped lang="scss">
.order-container {
  background: #ffffff;

  .order-content {
    padding: 60px 18% 0px;

    .span-red {
      color: #FE273B;
      font-size: 16px;
      margin-block-start: 0;
      margin-block-end: 0;
      cursor: context-menu;
    }

    .receipt-info {
      margin-top: 20px;
      padding: 20px 30px 20px 20px;
      border: 1px solid #DDDDDD;

      .title-content {
        margin-block-start: 0em;
        margin-block-end: 0em;

        .left-span {
          color: #333333;
          font-size: 16px;
          cursor: context-menu;
        }

        .el-link--primary {
          color: #1637FF;
          float: right;
          font-size: 14px;
        }
      }

      .add-address {
        line-height: 45px;
        font-size: 18px;
        color: #333333;
        cursor: context-menu;
      }
    }

    .goods-info {
      margin-top: 20px;
      padding: 20px 30px 20px 20px;
      border: 1px solid #DDDDDD;

      .title-content {
        margin-block-start: 0em;
        margin-block-end: 0em;
        cursor: context-menu;

        .left-span {
          color: #333333;
          font-size: 16px;
        }
      }

      .good-info {
        padding-top: 20px;
        display: flex;

        .goods-describe {
          width: 100%;

          p {
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding-left: 20px;
            cursor: context-menu;
          }

          .goods-name {
            color: #333333;
            font-size: 16px;
            padding-bottom: 15px;
          }

          .goods-gray {
            color: #666666;
            font-size: 14px;
            line-height: 22px;
          }

          .goods-price {
            font-size: 18px;
            color: #FE273B;
            padding-top: 5px;
          }

          .el-remarks {
            font-style: normal;
            color: #333333;
            line-height: 39px;
            padding: 0px 10px;
          }
        }
      }
    }
    .un-favourable-info{
      margin-top: 20px;
      padding: 20px;
      border: 1px solid #DDDDDD;
      display: flex;
      justify-content: space-between;
      .title-content {
        margin-block-start: 0em;
        margin-block-end: 0em;
        cursor: context-menu;
        .left-span {
          color: #333333;
          font-size: 16px;
        }
      }
    }
    .favourable-info {
      margin-top: 20px;
      padding: 0px 0px 20px 0px;
      border: 1px solid #DDDDDD;
      .title-content {
        margin-block-start: 0em;
        margin-block-end: 0em;
        cursor: context-menu;

        .left-span {
          color: #333333;
          font-size: 16px;
        }
      }
      .price {
        color: #FE273B;
        font-size: 30px;
        padding-bottom: 5px;
      }
      p {
        margin-block-start: 0em;
        margin-block-end: 0em;
      }
      .coupon-type {
        color: #FE273B;
        font-size: 12px;
      }
      .coupon-term{
        font-size: 14px;
        color: #333333;
      }
    }
    .payment-method{
      margin-top: 20px;
      padding: 20px 30px 20px 20px;
      border: 1px solid #DDDDDD;
      .title-content {
        margin-block-start: 0em;
        margin-block-end: 0em;
        cursor: context-menu;
        .left-span {
          color: #333333;
          font-size: 16px;
        }
      }
      .el-div{
        min-height: 34px;
        display: flex;
        justify-content: left;
        .payment-type{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          .coupon-term{
            font-size: 14px;
            color: #333333;
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding-left: 10px;
          }
          .icon-wechat{
            height: 20px;
            width: 21px;
            background: url("~@/assets/img/cloud/wecat.png");
            background-size: 100% 100%;
          }
          .icon-alipay{
            height: 20px;
            width: 21px;
            background: url("~@/assets/img/cloud/alipay.png");
            background-size: 100% 100%;
          }
          .icon-balance{
            height: 20px;
            width: 21px;
            background: url("~@/assets/img/cloud/balance.png");
            background-size: 100% 100%;
          }
        }
      }
    }
    .resoult-info{
      margin-top: 20px;
      min-height: 160px;
      p{
        margin-block-start: 0em;
        margin-block-end: 0em;
        cursor: context-menu;
        font-size: 14px;
        color: #333333;
        display: flex;
        justify-content: right;
        padding-bottom: 5px;
        .left-span{
          min-width: 100px;
          text-align: start;
        }
        .right-span{
          min-width: 80px;
          text-align: end;
        }
        .red-span{
          color: #FE273B;
        }
      }
    }
  }
}
</style>